
const getters = {
    device: (state) => state.app.device,
};
export default getters;
